import React from "react";

/* Contextual info box — replaces legacy uiComponents InfoPanel (MUI styled div).
   Default = fog-grey panel; optional tone presets or explicit background/colour. */

const TONES = {
  default: { background: "var(--grey-bg)", color: "var(--text-body)" },
  mint: { background: "var(--mint-light)", color: "var(--text-body)" },
  warning: { background: "var(--orange-soft)", color: "var(--text-body)" },
  error: { background: "#FDE5E5", color: "var(--red)" },
};

export function InfoPanel({
  children,
  style,
  tone = "default",
  background,
  colour,
  padding = 15,
  fontWeight = 600,
  noMargin = false,
  margin,
  ...rest
}) {
  const preset = TONES[tone] || TONES.default;
  return (
    <div
      {...rest}
      style={{
        background: background || preset.background,
        color: colour || preset.color,
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-start",
        alignSelf: "stretch",
        padding,
        gap: 10,
        borderRadius: "var(--radius-xs)",
        width: "100%",
        fontWeight,
        margin: noMargin ? 0 : margin || "0 0 16px",
        fontFamily: "var(--font-sans)",
        fontSize: 14,
        ...style,
      }}
    >
      {children}
    </div>
  );
}

export default InfoPanel;
